import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import { Chart } from "chart.js/auto"
window.Chart = Chart

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// --- Forty Theme: vanilla JS port ---

document.addEventListener("DOMContentLoaded", () => {
  // Remove loading state after a brief delay (allows CSS transitions to fire)
  window.setTimeout(() => {
    document.body.classList.remove("is-loading")
  }, 100)

  // --- Menu toggle ---
  const menuOpen = document.querySelector('a[href="#menu"]')
  const menuClose = document.querySelector("#menu .close")

  if (menuOpen) {
    menuOpen.addEventListener("click", (e) => {
      e.preventDefault()
      document.body.classList.add("is-menu-visible")
    })
  }

  if (menuClose) {
    menuClose.addEventListener("click", (e) => {
      e.preventDefault()
      document.body.classList.remove("is-menu-visible")
    })
  }

  // Close menu on clicking outside the inner content
  const menu = document.getElementById("menu")
  if (menu) {
    menu.addEventListener("click", (e) => {
      if (e.target === menu) {
        document.body.classList.remove("is-menu-visible")
      }
    })
  }

  // Close menu on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      document.body.classList.remove("is-menu-visible")
    }
  })

  // --- Header: show/hide on scroll ---
  const header = document.getElementById("header")
  const banner = document.getElementById("banner")

  if (header && banner) {
    let lastScroll = 0

    const updateHeader = () => {
      const bannerBottom = banner.offsetTop + banner.offsetHeight
      const scrollY = window.scrollY

      if (scrollY > bannerBottom) {
        // Past the banner: fixed header
        if (header.classList.contains("alt")) {
          header.classList.remove("alt")
          header.classList.add("reveal")
        }
      } else {
        // In the banner area: transparent header
        if (!header.classList.contains("alt")) {
          header.classList.add("alt")
          header.classList.remove("reveal")
        }
      }

      lastScroll = scrollY
    }

    window.addEventListener("scroll", updateHeader, { passive: true })
    updateHeader()
  }

  // --- Tile click transitions ---
  document.querySelectorAll(".tiles article").forEach((article) => {
    const link = article.querySelector("a")
    if (!link) return

    article.style.cursor = "pointer"

    article.addEventListener("click", (e) => {
      if (e.target.closest("a")) return // let direct link clicks through

      e.preventDefault()
      article.classList.add("is-transitioning")

      setTimeout(() => {
        window.location.href = link.href
      }, 500)
    })
  })

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      const targetId = anchor.getAttribute("href").slice(1)
      if (!targetId) return

      const target = document.getElementById(targetId)
      if (!target) return

      e.preventDefault()
      target.scrollIntoView({ behavior: "smooth" })
    })
  })
})
